// extracted by mini-css-extract-plugin
export var footerCheckboxContainer = "inscriptionNewsletter-module--footer-checkbox-container--798e0";
export var footerNewsletter = "inscriptionNewsletter-module--footer-newsletter--a2045";
export var footerNewsletterInput = "inscriptionNewsletter-module--footer-newsletter-input--fb876";
export var sectionAlert = "inscriptionNewsletter-module--section-alert--70af0";
export var sectionAlertButton = "inscriptionNewsletter-module--section-alert-button--efabf";
export var sectionAlertContent = "inscriptionNewsletter-module--section-alert-content--a6212";
export var sectionAlertHeader = "inscriptionNewsletter-module--section-alert-header--bb967";
export var sectionAlertModal = "inscriptionNewsletter-module--section-alert-modal--5c5c6";
export var sectionAlertTitle = "inscriptionNewsletter-module--section-alert-title--57af2";